<div class=" d-none d-md-block" style="height: 700px; margin-bottom: 40px;">
  <carousel [isAnimated]="true" [indicatorsByChunk]="true" [interval]="'-5'">
    <slide>
      <img class="img-fluid" src="https://res.cloudinary.com/dfqkwnen0/image/upload/v1602239528/Rectangle_7_aupay4.png"
        alt="first slide" style="display: block; height: 704px; width: 100%;">
      <div class="carouselCrad">
        <h3 class="cardHeader">Explore our Showroom</h3>
        <p class="cardSubtext">
          Not sure of what you’re looking for?
          No worries, use Lighting Xplorer to see what you can get.
        </p>
        <div class="cardBtn">
          Proceed to Lighting Xplorer
          <svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.1039 9.16487H18.6436L14.5551 13.6789C14.1054 14.1805 14.1054 14.9556 14.5551 15.4572C15.0049 15.9587 15.6999 15.9587 16.1496 15.4572L22.9366 7.88817L22.1598 7.02184L16.1496 0.36477C15.9452 0.136789 15.659 0 15.3728 0C15.0866 0 14.8004 0.136789 14.596 0.36477C14.1463 0.86633 14.1463 1.64147 14.596 2.14303L18.6436 6.65707H1.1039C0.490622 6.65707 0 7.20422 0 7.93377C0 8.61771 0.490622 9.16487 1.1039 9.16487Z"
              fill="#F4811F" />
          </svg>
        </div>
      </div>
    </slide>
    <slide>
      <img class="img-fluid" src="https://res.cloudinary.com/dfqkwnen0/image/upload/v1602239528/Rectangle_7_aupay4.png"
        alt="second slide" style="display: block; height: 704px; width: 100%;">
        <div class="carouselCrad">
          <h3 class="cardHeader">Explore our Showroom</h3>
          <p class="cardSubtext">
            Not sure of what you’re looking for?
            No worries, use Lighting Xplorer to see what you can get.
          </p>
          <div class="cardBtn">
            Proceed to Lighting Xplorer
            <svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.1039 9.16487H18.6436L14.5551 13.6789C14.1054 14.1805 14.1054 14.9556 14.5551 15.4572C15.0049 15.9587 15.6999 15.9587 16.1496 15.4572L22.9366 7.88817L22.1598 7.02184L16.1496 0.36477C15.9452 0.136789 15.659 0 15.3728 0C15.0866 0 14.8004 0.136789 14.596 0.36477C14.1463 0.86633 14.1463 1.64147 14.596 2.14303L18.6436 6.65707H1.1039C0.490622 6.65707 0 7.20422 0 7.93377C0 8.61771 0.490622 9.16487 1.1039 9.16487Z"
                fill="#F4811F" />
            </svg>
          </div>
        </div>
    </slide>
    <slide>
      <img class="img-fluid" src="https://res.cloudinary.com/dfqkwnen0/image/upload/v1602239528/Rectangle_7_aupay4.png"
        alt="third slide" style="display: block; height: 704px; width: 100%;">
        <div class="carouselCrad">
          <h3 class="cardHeader">Explore our Showroom</h3>
          <p class="cardSubtext">
            Not sure of what you’re looking for?
            No worries, use Lighting Xplorer to see what you can get.
          </p>
          <div class="cardBtn">
            Proceed to Lighting Xplorer
            <svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.1039 9.16487H18.6436L14.5551 13.6789C14.1054 14.1805 14.1054 14.9556 14.5551 15.4572C15.0049 15.9587 15.6999 15.9587 16.1496 15.4572L22.9366 7.88817L22.1598 7.02184L16.1496 0.36477C15.9452 0.136789 15.659 0 15.3728 0C15.0866 0 14.8004 0.136789 14.596 0.36477C14.1463 0.86633 14.1463 1.64147 14.596 2.14303L18.6436 6.65707H1.1039C0.490622 6.65707 0 7.20422 0 7.93377C0 8.61771 0.490622 9.16487 1.1039 9.16487Z"
                fill="#F4811F" />
            </svg>
          </div>
        </div>
    </slide>
  </carousel>
</div>

<div class="container-fluid d-sm-block d-md-none" style="margin-bottom: 40px;">
  <div class="mobileCard">
    <h3 class="cardHeader">Explore our Showroom</h3>
    <p class="cardSubtext">
      Not sure of what you’re looking for?
      No worries, use Lighting Xplorer to see what you can get.
    </p>
    <div class="cardBtn">
      Proceed to Lighting Xplorer
      <svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.1039 9.16487H18.6436L14.5551 13.6789C14.1054 14.1805 14.1054 14.9556 14.5551 15.4572C15.0049 15.9587 15.6999 15.9587 16.1496 15.4572L22.9366 7.88817L22.1598 7.02184L16.1496 0.36477C15.9452 0.136789 15.659 0 15.3728 0C15.0866 0 14.8004 0.136789 14.596 0.36477C14.1463 0.86633 14.1463 1.64147 14.596 2.14303L18.6436 6.65707H1.1039C0.490622 6.65707 0 7.20422 0 7.93377C0 8.61771 0.490622 9.16487 1.1039 9.16487Z"
          fill="#F4811F" />
      </svg>
    </div>
  </div>
</div>
